import {FC, SVGProps} from 'react';

/** Иконка «сброс / начать заново» для подтверждения смены гражданства или страны проживания. */
export const ConfirmationResetIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="71"
		height="92"
		viewBox="0 0 71 92"
		fill="none"
		aria-hidden
		{...props}
	>
		<path
			d="M35.26 80.7602V70.5202C17.58 70.5202 2.91 57.4402 0.39 40.4502C0.14 42.1502 0 43.8802 0 45.6402C0 65.0802 15.82 80.9002 35.26 80.9002V91.1402L52.16 73.3302V62.9402L35.26 80.7502V80.7602Z"
			fill="black"
		/>
		<path
			d="M55.3806 35.2596C55.3806 24.1696 46.3506 15.1396 35.2606 15.1396C24.1706 15.1396 15.1406 24.1696 15.1406 35.2596C15.1406 37.0596 15.3663 38.8362 15.8063 40.5062C18.1063 31.9262 25.9606 25.5296 35.2606 25.5296C46.3606 25.5296 55.3806 34.5597 55.3806 45.6497V35.2596Z"
			fill="black"
		/>
		<path d="M70.5189 47.9404H55.3789V58.3304H70.5189" fill="black" />
		<path
			d="M35.26 1.52C53.86 1.52 69 16.66 69 35.26V46.42H56.91V35.26C56.91 23.33 47.2 13.62 35.27 13.62C23.34 13.62 13.62 23.33 13.62 35.26C13.62 47.19 23.33 56.9 35.26 56.9H36.78V48.95L50.06 62.95L36.78 76.95V69H35.26C16.66 69 1.52 53.86 1.52 35.26C1.52 16.66 16.66 1.52 35.26 1.52ZM35.26 0C15.82 0 0 15.82 0 35.26C0 54.7 15.82 70.52 35.26 70.52V80.76L52.16 62.95L35.26 45.14V55.38C24.16 55.38 15.14 46.35 15.14 35.26C15.14 24.17 24.16 15.14 35.26 15.14C46.36 15.14 55.38 24.17 55.38 35.26V47.94H70.52V35.26C70.52 15.82 54.7 0 35.26 0Z"
			fill="black"
		/>
	</svg>
);
